module.exports = __webpack_public_path__ + "img/retreatBtn.ce7d0acd.png";